// JSON API deserialiser // TODO: why two?
import {AxiosRequestConfig} from 'axios';
import * as deserializeJsonApi from 'deserialize-json-api';
import Jsona from 'jsona';

import config from '../config';
import {rootStore} from '../stores/rootStore';

import apiService from './apiService';

const jsonaDeserialiser = new Jsona();

/**
 * The api doesn't return sticker in the line data for cart
 * so we do that here.
 */
async function cartLines(response: any) {
  const data = Array.isArray(response?.data?.data)
    ? response?.data?.data?.[0]
    : response?.data?.data;

  let order_id = data?.type === 'orders' && data?.id;

  // order is also updated from coupon validation so get the order id
  if (data?.type === 'coupon-validations') {
    order_id = response?.data?.included?.find(
      ({type}: any) => type === 'orders',
    )?.id;
  }

  // ensure cart response
  if (!order_id) {
    return [];
  }

  /**
   * Get lines for the sticker data
   */
  const lines = await apiService.searchLines({order_id});
  return lines || [];
}

export const jsonApiDeserialisationResponseInterceptor = async (
  response: any,
) => {
  const url = response.config.url;

  if (!url) return response;

  if (url.startsWith('/ecommerce') || url.startsWith('/support')) {
    // TODO: maybe just move JSONApi deserialisation to the middleware?
    if (
      [
        '/ecommerce/order',
        '/ecommerce/order/recent',
        '/ecommerce/delivery-details',
        '/ecommerce/order-note',
        '/ecommerce/coupon',
        '/ecommerce/order-validate',
        '/ecommerce/order-checkout',
      ].includes(url) ||
      url.match(/\/ecommerce\/orders\/[a-z0-9]{24}/)
    ) {
      let included = response?.data?.included || [];

      if (config.FF_LOYALTY_ENABLED) {
        /**
         * Need to fetch more lines
         */
        const augmentLines = ((await cartLines(response)) as any[]) || [];
        included = !config.FF_LOYALTY_ENABLED
          ? included
          : [...included, ...augmentLines];
      }

      const result = deserializeJsonApi.deserialize({
        ...response.data,
        included,
      });

      /**
       * kind of hack to add activated deals to object
       * the problem is activated_deals is not in included so is not in the order object. add it back here
       */
      const activated_deals =
        response?.data?.data?.[0]?.relationships?.activated_deals?.data?.map(
          ({id}: any) => id,
        );

      if (result?.data?.[0] && activated_deals) {
        result.data[0].activated_deals = activated_deals;
      }

      return result;
    } else if (url === '/ecommerce/departments/lines') {
      // Need to include metadata to enable pagination.
      const meta = response.data.meta;
      return {data: jsonaDeserialiser.deserialize(response.data), meta};
    }

    // Infer JSON API deserialisation with presence of response.data.data - https://jsonapi.org/format/#document-top-level
    if (response.data.data) {
      const deserialisedResponseData = jsonaDeserialiser.deserialize(response.data);
      if (!deserialisedResponseData) {
        console.error(`Deserialised 'response.data' is empty, double check whether data is JSON API formatted`, response.data);
        return response;
      }
      return deserialisedResponseData;
    }

    return response;
  }

  if (url === '/catalogues/catalogueHtml' || url === '/3ds/browserDataJs') {
    return response.data;
  }

  return response;
};

export const mflAuthHeadersRequestInterceptor = (
  axiosRequestConfig: AxiosRequestConfig,
) => {
  if (
    axiosRequestConfig.headers &&
    (axiosRequestConfig.url?.includes('/ecommerce') ||
      axiosRequestConfig.url?.includes('/competitions') ||
      axiosRequestConfig.url?.includes('/competition-entries') ||
      axiosRequestConfig.url?.includes('/rewards') ||
      axiosRequestConfig.url?.includes('/aggregate')) // not needed yet but will be
  ) {
    // Changes when person logs out of the app
    const deviceId = rootStore?.globalStore?.deviceId as string;
    const sessionSecret = rootStore?.userStore?.sessionSecret as string;
    const sessionToken = rootStore?.userStore?.sessionToken as string;

    axiosRequestConfig.headers.deviceId = deviceId;
    axiosRequestConfig.headers.sessionSecret = sessionSecret;
    axiosRequestConfig.headers.sessionToken = sessionToken;
  }
  return axiosRequestConfig;
};
